import React, {Fragment} from 'react';
import {DI} from 'modules';
import Component from 'components/component';
import Form from 'common/components/form/new-form';
import {Provider, PrimaryUrl, PrimarySRTUrl, BackupUrl, StreamKey, Password, Username, IPAddress} from './fields';
import TVUFields from './target-tvu-fields';

export class TargetForm extends Component {
    state = {
        form: {
            key: ''
        }
    };

    onChange = (ev, form) => {
        this.setState({form});
    };

    onSubmit = (ev, form) => {
        const onValidateForm = this.onValidateForm;

        if (onValidateForm.panic()) {
            this.props.actions.targets
                .createTarget(this.props.liveEvent.slug, form)
                .then((resp) => {
                    this.props.close();
                    return resp;
                });
        }
    };

    onValidateForm = () => {};

    render() {
        const form = this.state.form;
        const strings = this.props.common.strings;

        return (
            <Form onChange={this.onChange} onSubmit={this.onSubmit}>
                {this.props.targetParams.map(([name, value]) => (
                    <input key={name} type="hidden" name={name} value={value} />
                ))}
                <input
                    type="hidden"
                    name="language_id"
                    value={this.props.selectedLanguageID}
                />
                <div className="popup-stream">
                    <span className="popup__title">
                        {strings['page.lives.view.add_stream.title']}
                    </span>
                    <div className="stream">
                        <span
                            className={`stream__title stream__title--${
                                this.props.id
                            }`}
                        >
                            {this.props.targetName}
                        </span>
                        <FormInner strings={strings}
                                   form={form}
                                   onValidateForm={this.onValidateForm}
                                   targetType={this.props.targetType}
                                   custom={this.props.custom}
                                   providers={this.props.targets.providers.payload}
                        />
                    </div>
                    {this.props.children}
                    <div className="popup-buttons popup-buttons--border">
                        <div className="popup-button">
                            <button
                                type="button"
                                className="text-button"
                                onClick={this.props.close}
                            >
                                {strings['page.lives.view.add_stream.cancel']}
                            </button>
                        </div>
                        <div className="popup-button">
                            <button type="submit" className="button">
                                {strings['page.lives.view.add_stream.submit']}
                            </button>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

function CustomRtmpForm(props){
    return (
        <Fragment>
            <StreamKey {...props}/>
            <Provider {...props}/>
            <PrimaryUrl {...props}/>
            <BackupUrl {...props}/>
            <span className="fields__title">
                        {props.strings['page.lives.view.add_stream.optional_subtitle']}
                    </span>
            <Username {...props}/>
            <Password {...props}/>
        </Fragment>
    );
}

function FacebookForm(props){
    return <StreamKey {...props}/>;
}

function DefaultForm(props){
    return (
        <Fragment>
            <PrimaryUrl {...props}/>
            <StreamKey {...props}/>
        </Fragment>
    );
}

function SrtForm(props){
    return (
        <PrimarySRTUrl {...props}/>
    );
}

function HLSFullHDForm(props){
    return (
        <IPAddress {...props}/>
    );
}

function TVUForm(props){
    return (
        <TVUFields {...props}/>
    );
}

function FormInner(props) {
    return (
        <div className="stream-form">
            {[
                'periscope',
                'vkontakte',
                'odnoklassniki'
            ].includes(props.targetType) && (
                <DefaultForm {...props}/>
            )}

            {(props.targetType === 'facebook' || props.targetType === 'youtube') && (
                <FacebookForm {...props}/>
            )})

            {props.custom && (
                <CustomRtmpForm {...props}/>
            )}

            {props.targetType === 'srt' && (
                <SrtForm {...props}/>
            )}
            {props.targetType === 'hls_full_hd' && (
                <HLSFullHDForm {...props}/>
            )}
            {props.targetType === 'tvu' && (
                <TVUForm {...props}/>
            )}
        </div>
    );
}

export default DI(['targets'])(TargetForm);
